import { Classes } from '@clarion-blueprint-shim';

export default function Audit16() {
  return (
    <span className={Classes.ICON}>
      <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
        <g>
          <path
            fillRule="evenodd"
            d="m16.0521 14.1001-2.6578-2.6069c.6968-1.0603 1.105-2.3151 1.105-3.65747 0-3.76445-3.1157-6.80909-6.96793-6.80909-3.85225 0-6.9679 3.04464-6.9679 6.80909 0 3.76447 3.11565 6.80907 6.9679 6.80907 1.38362 0 2.66773-.4085 3.74273-1.0797l2.6677 2.5972c.2688.2626.647.428 1.0552.428.8262 0 1.4931-.6517 1.4931-1.4591 0-.3988-.1692-.7685-.438-1.0311Zm-8.52073-1.4007c-2.74734 0-4.97707-2.1789-4.97707-4.86367 0-2.68472 2.22973-4.86363 4.97707-4.86363 2.74733 0 4.97703 2.17891 4.97703 4.86363 0 2.68477-2.2297 4.86367-4.97703 4.86367Z"
            clipRule="evenodd"
          />
          <path d="M5.5505 6.87274c.27872 0 .52757.107.70675.28209l1.00536 1.00191 1.37367-2.68473h.00996c.16922-.321.49771-.54472.88592-.54472.54744 0 .99544.43772.99544.97272 0 .15564-.0498.30155-.1095.428h.0099L8.4372 10.2189h-.00995c-.16922.321-.49771.5448-.88592.5448-.27872 0-.52757-.107-.70674-.2821L4.84376 8.53611c-.17917-.1751-.28867-.41828-.28867-.69064 0-.535.44794-.97273.99541-.97273Z" />
        </g>
      </svg>
    </span>
  );
}
